import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Select from "react-select";
import WorkLineForm from "./WorkLineForm";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../auth/useAuth";
import { getAnalisysTypes } from "../../actions/analisysTypesActions";
import { getParameters } from "../../actions/parametersActions";

export default function AmpliationForm({
    state,
    ampliations,
    setAmpliations,
    onSubmitAmpliations,
    isAddingOrEditing,
    isRegistering,
    userType,
    handleConvertToWO
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { clientauth } = useAuth();
    const { analisysTypes } = useSelector(state => state.analisysTypes);
    const { parameters } = useSelector(state => state.parameters);

    const [modalShow, setModalShow] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingAIndex, setEditingAIndex] = useState(null);
    const [editingWIndex, setEditingWIndex] = useState(null);
    const [workLineType, setWorkLineType] = useState("Análisis");

    const [errorMessage, setErrorMessage] = useState("");
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);

    const [currentAmpliation, setCurrentAmpliation] = useState({
        name: "",
        workLines: [],
        state: "Pendiente",
        date: new Date().toISOString().slice(0, 10)
    });

    const [pendingStates, setPendingStates] = useState({});

    const [workLineAux, setWorkLineAux] = useState({
        typeLine: "Análisis",
        description: "",
        quantity: 0,
        params: [],
        price: 0,
        recurrence: "Sin recurrencia",
        status: "Pendiente",
        amountRecurrence: 1
    });

    useEffect(() => {
        if (clientauth) {
            dispatch(getAnalisysTypes());
            dispatch(getParameters());
        }
    }, [dispatch, clientauth]);

    useEffect(() => {
        setPendingStates(
            ampliations.reduce((acc, amp, index) => {
                acc[index] = amp.state;
                return acc;
            }, {})
        );
    }, [ampliations]);

    // openModal (aIndex, typeLine, wIndex, readonly):
    // - (null, typeLine)                   → añadir línea a la ampliación actual
    // - (null, typeLine, wIndex)           → editar línea de la ampliación actual
    // - (aIndex, typeLine)                 → añadir línea a una ampliación existente
    // - (aIndex, typeLine, wIndex)         → editar línea dentro de una ampliación existente
    // - (aIndex, typeLine, wIndex, true)   → ver línea en modo solo lectura
    const openModal = (aIndex = null, typeLine = "Análisis", wIndex = null, readOnly = false) => {
        setWorkLineType(typeLine);
        setIsReadOnlyModal(readOnly);

        if (Number.isInteger(aIndex) && Number.isInteger(wIndex)) {
            setIsEditing(true);
            setEditingAIndex(aIndex);
            setEditingWIndex(wIndex);
            const line = ampliations[aIndex].workLines[wIndex];
            setWorkLineAux({ ...line });
        } else if (Number.isInteger(aIndex)) {
            setIsEditing(false);
            setEditingAIndex(aIndex);
            setEditingWIndex(null);
            setWorkLineAux({
                typeLine,
                description: "",
                quantity: 0,
                params: [],
                price: 0,
                recurrence: "Sin recurrencia",
                status: "Pendiente",
                amountRecurrence: 1
            });
        } else if (Number.isInteger(wIndex)) {
            setIsEditing(true);
            setEditingAIndex(null);
            setEditingWIndex(wIndex);
            setWorkLineAux({ ...currentAmpliation.workLines[wIndex] });
        } else {
            setIsEditing(false);
            setEditingAIndex(null);
            setEditingWIndex(null);
            setWorkLineAux({
                typeLine,
                description: "",
                quantity: 0,
                params: [],
                price: 0,
                recurrence: "Sin recurrencia",
                status: "Pendiente",
                amountRecurrence: 1
            });
        }

        setModalShow(true);
    };

    const handleInputChangeModal = ({ target }) => {
        setWorkLineAux(prev => ({ ...prev, [target.name]: target.value }));
    };

    const handleSelectChangeModal = ({ target }) => {
        setWorkLineAux(prev => ({ ...prev, [target.name]: target.value }));
    };

    const handleSubmitModal = () => {
        if (isReadOnlyModal) {
            setModalShow(false);
            return;
        }

        if (isEditing && editingAIndex !== null && editingWIndex !== null) {
            setAmpliations(prev =>
                prev.map((amp, i) =>
                    i === editingAIndex
                        ? {
                            ...amp,
                            workLines: amp.workLines.map((wl, j) =>
                                j === editingWIndex ? { ...workLineAux } : wl
                            )
                        }
                        : amp
                )
            );
            setModalShow(false);
            return;
        }

        if (!isEditing && editingAIndex !== null) {
            setAmpliations(prev =>
                prev.map((amp, i) =>
                    i === editingAIndex
                        ? { ...amp, workLines: [...amp.workLines, workLineAux] }
                        : amp
                )
            );
            setModalShow(false);
            return;
        }

        if (isEditing && editingAIndex === null && editingWIndex !== null) {
            setCurrentAmpliation(prev => ({
                ...prev,
                workLines: prev.workLines.map((wl, j) =>
                    j === editingWIndex ? { ...workLineAux } : wl
                )
            }));
            setModalShow(false);
            return;
        }

        setCurrentAmpliation(prev => ({
            ...prev,
            workLines: [...prev.workLines, workLineAux]
        }));

        setWorkLineAux({
            typeLine: "Análisis",
            description: "",
            quantity: 0,
            params: [],
            price: 0,
            recurrence: "Sin recurrencia",
            status: "Pendiente",
            amountRecurrence: 1
        });

        setModalShow(false);
    };

    const removeWorkLine = (aIndex, wIndex) => {
        setAmpliations(prev =>
            prev.map((amp, i) =>
                i === aIndex
                    ? { ...amp, workLines: amp.workLines.filter((_, j) => j !== wIndex) }
                    : amp
            )
        );
    };

    const deleteAmpliation = (aIndex) => {
        setAmpliations(prev => prev.filter((_, index) => index !== aIndex));
    };

    const handleCurrentAmpliationNameChange = (e) => {
        setCurrentAmpliation(prev => ({ ...prev, name: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrorMessage("");

        const hasName = currentAmpliation.name.trim().length > 0;
        const hasLines = currentAmpliation.workLines.length > 0;

        if (hasName && !hasLines) {
            setErrorMessage("admin.budgets.error.noWorkLines");
            return;
        }
        if (!hasName && hasLines) {
            setErrorMessage("admin.budgets.error.noName");
            return;
        }

        let updated = ampliations;

        if (hasName && hasLines) {
            updated = [...ampliations, currentAmpliation];
            setAmpliations(updated);
            setCurrentAmpliation({
                name: "",
                workLines: [],
                state: "Pendiente",
                date: new Date().toISOString().slice(0, 10)
            });
        }

        const finalAmpliations = updated.map((amp, index) => ({
            ...amp,
            state: pendingStates[index] ?? amp.state
        }));

        onSubmitAmpliations(finalAmpliations);
    };

    const renderWorkLineCards = (workLines, aIndex, isBlocked, status) => {
        console.log(status)
        if (workLines.length === 0) {
            return <p className="text-muted">{t("admin.budgets.noWorkLines")}</p>;
        }

        return (
            <Row>
                {workLines.map((line, wIndex) => {
                    const isAnalysis = line.typeLine === "Análisis";
                    const totalParams = isAnalysis ? (line.params?.length || 0) : null;

                    return (
                        <Col key={wIndex} xs={12} md={4} className="mb-4">
                            <Card className="h-100 shadow-sm">
                                <Card.Body className="p-4 d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div>
                                            <div className="text-uppercase text-secondary fw-semibold small">
                                                {isAnalysis ? t("admin.budgets.analysisType") : t("admin.budgets.extraService")}
                                            </div>
                                            {isAnalysis && (
                                                <h5 className="m-0 fw-bold fs-4">
                                                    {line.description || t("admin.budgets.workLineDescription")}
                                                </h5>
                                            )}
                                        </div>

                                        <div className="d-flex gap-2">
                                            {(status === "Aprobado") && isAnalysis && (
                                                <Button
                                                    variant="light"
                                                    className={'p-2 rounded-circle shadow-sm'}
                                                    disabled={line.status !== "Pendiente"}
                                                    onClick={(e) => {
                                                        if (line.status === "Pendiente") {
                                                            handleConvertToWO(e, state.id, aIndex, wIndex);
                                                        }
                                                    }}
                                                >
                                                    <i className="fa-solid fa-arrow-right-from-bracket"></i>
                                                </Button>
                                            )}
                                            {!isBlocked ? (
                                                <>
                                                    <Button
                                                        variant="light"
                                                        className="p-2 rounded-circle shadow-sm text-danger"
                                                        onClick={() => removeWorkLine(aIndex, wIndex)}
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </Button>
                                                    <Button
                                                        variant="light"
                                                        className="p-2 rounded-circle shadow-sm"
                                                        onClick={() => openModal(aIndex, line.typeLine, wIndex, false)}
                                                    >
                                                        <i className="fas fa-pencil"></i>
                                                    </Button>
                                                </>
                                            ) :
                                                isAnalysis && (
                                                    <Button
                                                        variant="light"
                                                        className="p-2 rounded-circle shadow-sm"
                                                        onClick={() => openModal(aIndex, line.typeLine, wIndex, true)}
                                                    >
                                                        <i className="fa-solid fa-eye"></i>
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <Row className="mb-3">
                                        <Col xs={6}>
                                            <div className="fw-semibold text-secondary">{t("admin.budgets.price")} (€)</div>
                                            <div className="fs-5 fw-bold">{line.price} €</div>
                                        </Col>
                                        <Col xs={6}>
                                            <div className="fw-semibold text-secondary">{t("admin.budgets.recurrence")}</div>
                                            <div className="fs-6 fw-semibold">{line.recurrence}</div>
                                        </Col>
                                    </Row>

                                    {isAnalysis ?
                                        <>
                                            <div className="mt-auto pt-3 border-top">
                                                <Row>
                                                    <Col xs={6}>
                                                        <div className="fw-semibold text-secondary">{t("admin.budgets.analisysQuantity")}</div>
                                                        <div className="fs-6 fw-semibold">{line.quantity}</div>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <div className="fw-semibold text-secondary">Total parámetros</div>
                                                        <div className="fs-6 fw-semibold">{totalParams}</div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="mt-auto pt-3 border-top flex-grow-1 d-flex align-items-start">
                                                <div className="w-100">
                                                    <div className="fw-semibold text-secondary mb-1">
                                                        {t("admin.budgets.workLineDescription")}
                                                    </div>
                                                    <p className="mb-0" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                                        {line.description || "—"}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    return (
        <>
            <Form onSubmit={handleSubmit} className="px-4 formulario">
                <Row className="my-4">
                    <Col xs={12} md={7}>
                        <Form.Label>{t("admin.budgets.ampliationName")}</Form.Label>
                        <Form.Control
                            className="sd-input"
                            type="text"
                            name="name"
                            value={currentAmpliation.name}
                            onChange={handleCurrentAmpliationNameChange}
                        />
                    </Col>

                    <Col xs={12} md={5} className="d-flex justify-content-end gap-2 align-items-end">
                        <Button variant="fourth" onClick={() => openModal(null, "Análisis")}>
                            {t("admin.budgets.addAnalysisType")}
                        </Button>

                        <Button variant="secondary" onClick={() => openModal(null, "Servicio")}>
                            {t("admin.budgets.addExtraService")}
                        </Button>
                    </Col>

                    <hr className="mt-5" />

                    <Col xs={12}>
                        {ampliations.length > 0 ? (
                            ampliations.map((ampliation, aIndex) => {
                                const isBlocked = ampliation.state !== "Pendiente";
                                const status = ampliation.state;

                                return (
                                    <Card key={aIndex} className="mb-4 shadow-sm">
                                        <Card.Header className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong className="me-3">{ampliation.name}</strong>
                                                <span>{ampliation.date}</span>
                                            </div>
                                            {!isBlocked && (
                                                <Button
                                                    variant="link"
                                                    className="p-0 text-dark text-decoration-none"
                                                    onClick={() => deleteAmpliation(aIndex)}
                                                >
                                                    <i className="fas fa-times"></i>
                                                </Button>
                                            )}
                                        </Card.Header>

                                        <Card.Body>
                                            {!isBlocked && (
                                                <Col xs={12} className="d-flex justify-content-end gap-2 mb-3">
                                                    <Button variant="fourth" onClick={() => openModal(aIndex, "Análisis")}>
                                                        {t("admin.budgets.addAnalysisType")}
                                                    </Button>

                                                    <Button variant="secondary" onClick={() => openModal(aIndex, "Servicio")}>
                                                        {t("admin.budgets.addExtraService")}
                                                    </Button>
                                                </Col>
                                            )}

                                            {renderWorkLineCards(ampliation.workLines, aIndex, isBlocked, status)}
                                        </Card.Body>

                                        <Card.Footer>
                                            <Select
                                                className="select"
                                                classNamePrefix="sd-select"
                                                options={[
                                                    { value: "Pendiente", label: "Pendiente" },
                                                    { value: "Aprobado", label: "Aprobado" },
                                                    { value: "Rechazado", label: "Rechazado" },
                                                    { value: "Cancelado", label: "Cancelado" }
                                                ]}
                                                value={{ value: pendingStates[aIndex], label: pendingStates[aIndex] }}
                                                onChange={(selected) =>
                                                    setPendingStates(prev => ({ ...prev, [aIndex]: selected.value }))
                                                }
                                                isDisabled={isBlocked}
                                            />
                                        </Card.Footer>
                                    </Card>
                                );
                            })
                        ) : (
                            <p>{t("admin.budgets.noAmpliations")}</p>
                        )}
                    </Col>

                    {currentAmpliation.workLines.length > 0 && (
                        <Col xs={12} className="mt-4">
                            <h5>{t("admin.budgets.newAmpliationPreview")}</h5>
                            <Card className="mb-4 shadow-sm">
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <strong>{currentAmpliation.name || t("admin.budgets.withoutName")}</strong>
                                    <Button
                                        variant="link"
                                        className="p-0 text-dark text-decoration-none"
                                        onClick={() =>
                                            setCurrentAmpliation(prev => ({ ...prev, name: "", workLines: [] }))
                                        }
                                    >
                                        <i className="fas fa-times"></i>
                                    </Button>
                                </Card.Header>

                                <Card.Body>
                                    <Row>
                                        {currentAmpliation.workLines.map((line, wIndex) => {
                                            const isAnalysis = line.typeLine === "Análisis";
                                            const totalParams = isAnalysis ? (line.params?.length || 0) : null;

                                            return (
                                                <Col key={wIndex} xs={12} md={4} className="mb-4">
                                                    <Card className="h-100 shadow-sm">
                                                        <Card.Body className="p-4 d-flex flex-column">

                                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                                <div>
                                                                    <div className="text-uppercase text-secondary fw-semibold small">
                                                                        {isAnalysis ? t("admin.budgets.analysisType") : t("admin.budgets.extraService")}
                                                                    </div>
                                                                    <h5 className="m-0 fw-bold fs-4">
                                                                        {line.description || t("admin.budgets.workLineDescription")}
                                                                    </h5>
                                                                </div>
                                                                <div className="d-flex gap-2">
                                                                    <Button
                                                                        variant="light"
                                                                        className="p-2 rounded-circle shadow-sm"
                                                                        onClick={() => openModal(null, line.typeLine, wIndex)}
                                                                    >
                                                                        <i className="fas fa-pencil"></i>
                                                                    </Button>
                                                                    <Button
                                                                        variant="light"
                                                                        className="p-2 rounded-circle shadow-sm text-danger"
                                                                        onClick={() =>
                                                                            setCurrentAmpliation(prev => ({
                                                                                ...prev,
                                                                                workLines: prev.workLines.filter((_, i) => i !== wIndex)
                                                                            }))
                                                                        }
                                                                    >
                                                                        <i className="fas fa-trash"></i>
                                                                    </Button>
                                                                </div>
                                                            </div>

                                                            <Row className="mb-3">
                                                                <Col xs={6}>
                                                                    <div className="fw-semibold text-secondary">{t("admin.budgets.price")} (€)</div>
                                                                    <div className="fs-5 fw-bold">{line.price} €</div>
                                                                </Col>
                                                                <Col xs={6}>
                                                                    <div className="fw-semibold text-secondary">{t("admin.budgets.recurrence")}</div>
                                                                    <div className="fs-6 fw-semibold">{line.recurrence}</div>
                                                                </Col>
                                                            </Row>

                                                            {isAnalysis && (
                                                                <div className="mt-auto pt-3 border-top">
                                                                    <Row>
                                                                        <Col xs={6}>
                                                                            <div className="fw-semibold text-secondary">{t("admin.budgets.analisysQuantity")}</div>
                                                                            <div className="fs-6 fw-semibold">{line.quantity}</div>
                                                                        </Col>
                                                                        <Col xs={6}>
                                                                            <div className="fw-semibold text-secondary">Total parámetros</div>
                                                                            <div className="fs-6 fw-semibold">{totalParams}</div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            )}
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    )}

                    <Row className="my-3 align-items-end justify-content-end">
                        <Col xs={12} lg={4} className="d-flex flex-column align-items-end">
                            {errorMessage && (
                                <div className="w-100 text-start text-danger mb-1">
                                    {t(errorMessage)}
                                </div>
                            )}
                            {userType === "Admin" && (
                                <Button variant="primary" type="submit" className="w-100">
                                    {isRegistering
                                        ? <span className="spinner-border spinner-border-sm"></span>
                                        : isAddingOrEditing === "editing"
                                            ? t("global.edit")
                                            : t("global.register")}
                                </Button>
                            )}
                        </Col>
                    </Row>
                </Row>
            </Form>

            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>{isReadOnlyModal ? t('admin.budgets.paramList') : t('admin.budgets.workLine')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <WorkLineForm
                        state={workLineAux}
                        handleInputChange={handleInputChangeModal}
                        parameters={parameters}
                        analisysTypes={analisysTypes}
                        handleSelectChange={handleSelectChangeModal}
                        submit={handleSubmitModal}
                        workLine={workLineAux}
                        isEditing={isEditing}
                        isReadOnly={isReadOnlyModal}
                        workLineType={workLineType}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}